import axios from 'axios';

const apiUrl = window._infl.api.url;
const orgId = window._infl.hub.id;

const instance = axios.create({
  baseUrl: apiUrl,
  headers: {
    'X_ORG_ID': orgId
  }
});

const { get } = window.jwt(instance, axios);

export const getAllLanguages = () => get(apiUrl + '/api/settings/translations/language_options');



// WEBPACK FOOTER //
// ./src/corporate/components/preview_email/api.js